module.exports = __webpack_public_path__ + "static/loja_2-2d600e73f676763471cc5fb5a9169ee9.png";